<template>
  <div class="container">
    <div class="login-container card-wrap" v-loading="loading">
      <h2 style="color: #f2af46; margin-bottom: 40px;">江铃餐饮商城商户管理平台</h2>
      <el-form :model="loginForm" :rules="loginRules" ref="loginFormRef" label-width="20px">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名">
            <template #prefix>
              <el-icon>
                <User />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password" class="login-form-item">
          <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" @keyup.enter.native="login('loginFormRef')">
            <template #prefix>
              <el-icon>
                <Lock />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="margin-top: 40px;">
        <el-button type="primary" @click="login('loginFormRef')">登录</el-button>
        <el-button @click="resetForm('loginFormRef')" style="margin-left: 30px;">重置</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { useAuthStore } from "@/store/auth";
  import api from "@/api/request";

  export default {
    data() {
      return {
        loginForm: {
          username: '',
          password: ''
        },
        loginRules: {
          username: [
            { required: true, message: '请输入用户名', trigger: 'blur' },
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ]
        },
        loading: false,
      }
    },
    methods: {
      login(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            this.loading = true
            // 登录逻辑，例如发送 axios 请求
            try {
              const response = await api.post('/authorize-center-server/security/login/username_password', {
                username: this.loginForm.username,
                password: this.loginForm.password,
                userType: 'TENANT',
              });

              const authStore = useAuthStore();
              authStore.setToken(response.data.token);
              authStore.setInProject(false)
              this.$router.push({path: '/dashboard'});
            } catch (error) {}
            this.loading = false
          } else {
            console.log('登录失败');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
    setup() {
      const authStore = useAuthStore();
      return { authStore };
    }
  }
</script>

<style lang="scss" scoped>
.container {
  background: url("../assets/img.png") no-repeat center center;
  height: 100vh;
  width: 100vw;
  background-size: cover;
  position: absolute;
  left: 0;
  top: 0;
}

.login-container {
  width: 300px;
  margin: 200px auto;
  padding: 15px 30px 15px 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.card-wrap{
  border-radius: 4px;
  border: 1px solid #e6ebf5;
  background-color: rgba(255, 255, 255);
  overflow: hidden;
  color: #303133;
  -webkit-transition: .3s;
  transition: .3s;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 50%);
  /*margin: 10px;*/
}

.login-container h2 {
  text-align: center;
  margin-bottom: 20px;
}

</style>